import { Box, styled } from '@mui/joy';

import { HEADER_HEIGHT, LEFT_MENU_WIDTH } from 'theme/constants';

export const PageWrapper = styled(Box)({
  display: 'flex',
  width: '100%',
  minHeight: '100vh',
});

export const PageRightWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minHeight: '100vh',
  overflow: 'hidden',
  background: theme.vars.palette.background.level1,
}));

export const PageContentWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'scrollable',
})<{ scrollable?: boolean }>(({ scrollable }) => ({
  position: 'fixed',
  top: HEADER_HEIGHT,
  display: 'flex',
  flexDirection: 'column',
  width: `calc(100vw - ${LEFT_MENU_WIDTH}px)`,
  height: `calc(100vh - ${HEADER_HEIGHT}px)`,
  overflow: scrollable ? 'auto' : 'hidden',
  padding: '16px 24px 0',
  gap: '16px',
}));
